/**
 * The business, as it should appear on an invoice.
 *
 * Edit this file. `stateCode` is the first two digits of your GSTIN — it decides
 * whether a sale is taxed as CGST + SGST (same state) or IGST (another state).
 */
export const SHOP = {
  name: 'Vipin Hair Extension',
  tagline: 'Wholesale Hair Extensions',
  addressLines: ['Sector 12, Vaishali Nagar', 'Jaipur, Rajasthan 302021'],
  gstin: '08AAAAA0000A1Z5',
  phone: '+91 98290 00000',
  email: 'accounts@vipinhair.example',
  bank: {
    name: 'State Bank of India',
    account: '0000 0000 0000',
    ifsc: 'SBIN0000000',
  },
  terms: [
    'Goods once sold will not be taken back.',
    'Interest @18% p.a. is charged on bills not paid within 30 days.',
    'Subject to Jaipur jurisdiction.',
  ],
};

export const shopStateCode = () => String(SHOP.gstin || '').slice(0, 2);

/**
 * Where the customer is, for tax purposes.
 *
 * A GSTIN begins with the state code. Same state as the shop means the tax splits
 * into CGST and SGST, half each. Anywhere else, it is one IGST line at the full
 * rate. A customer with no GSTIN is an unregistered local buyer, which is the
 * same split as intra-state.
 */
export function isIntraState(customerGstin) {
  const theirs = String(customerGstin || '').slice(0, 2);
  if (!theirs) return true;
  return theirs === shopStateCode();
}
